import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { PlatformService } from '@app/shared/services/platform/platform.service';

@Injectable()
export class ImagesService {
  buildUrl(path, width, height): string {
    let url = environment.imagesPath + '/cdn-cgi/image/';

    if (width) {
      url += 'w=' + width + ',';
    }
    if (height) {
      url += 'h=' + height + ',';
    }

    url += `q=80,f=auto,${path}`;
    return url;
  }
}
